// extracted by mini-css-extract-plugin
export default {"Templates":"ContractTemplates_Templates__NDs-b","TemplateList":"ContractTemplates_TemplateList__oHGTR"};